import { format } from 'date-fns'

export type AnalyticsEngine = {
  queryEvents<T = any>(sql: string): Promise<T[]>
}

/* -------------------------------------------------------------------------- */
/*                      Get usage From Analytics Engine                       */
/* -------------------------------------------------------------------------- */

export const getDeliveryApiRequestsUsage = async (
  analyticsEngine: AnalyticsEngine,
  teamId: string,
  lastSynced: number
) => {
  const lastSyncedDate = format(new Date(lastSynced), 'yyyy-MM-dd HH:mm:ss')

  const query = `
    SELECT index1 as teamId, SUM(_sample_interval) AS total_requests
    FROM basehub_analytics
    WHERE teamId = '${teamId}'
    AND timestamp >= toDateTime('${lastSyncedDate}')
    GROUP BY teamId
  `

  try {
    const result = await analyticsEngine.queryEvents<{
      total_requests: string
    }>(query)
    const request_count = Number(result[0]?.total_requests ?? 0)

    return { request_count }
  } catch (error) {
    console.error('Error querying API usage from Analytics Engine:', error)
    return { request_count: 0 }
  }
}

export const getDeliveryApiRequestsUsagePerRepo = async (
  analyticsEngine: AnalyticsEngine,
  teamId: string,
  repoId: string,
  lastSynced: number
) => {
  const lastSyncedDate = format(new Date(lastSynced), 'yyyy-MM-dd HH:mm:ss')

  const query = `
    SELECT index1 as teamId, blob2 as repoId, SUM(_sample_interval) AS total_requests
    FROM basehub_analytics
    WHERE teamId = '${teamId}'
    AND repoId = '${repoId}'
    AND timestamp >= toDateTime('${lastSyncedDate}')
    GROUP BY teamId, repoId
  `

  try {
    const result = await analyticsEngine.queryEvents<{
      total_requests: string
    }>(query)
    const request_count = Number(result[0]?.total_requests ?? 0)

    return { request_count }
  } catch (error) {
    console.error('Error querying repo API usage from Analytics Engine:', error)
    return { request_count: 0 }
  }
}
